import React from 'react';
interface ContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  className?: string;
}
export function Container({
  children,
  className = '',
  ...props
}: ContainerProps) {
  return <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 ${className}`} {...props} data-id="element-308">
      {children}
    </div>;
}